import { adminState, getApi, http, adminGet, adminPost, adminPut } from './useAdminCore';
// ==================== Categories ====================
function getCategories(onSuccess = null) {
    adminState.categoriesLoading = true;
    adminState.categoriesError = null;
    adminGet("/Discounts/Categories", (result) => {
        adminState.categories = result;
        adminState.categoriesLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createCategory(categoryData, onSuccess = null, onError = null) {
    adminPost('/Discounts/Categories', categoryData, (data) => {
        getCategories();
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        const errorMsg = 'Failed to create category';
        adminState.categoriesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function updateCategory(id, categoryData, onSuccess = null, onError = null) {
    adminPut('/Discounts/Categories/' + id, categoryData, (data) => {
        getCategories();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        const errorMsg = 'Failed to update category';
        adminState.categoriesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function deleteCategory(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Discounts/Categories/' + id)
        .then((response) => {
        getCategories();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        const errorMsg = 'Failed to delete category';
        adminState.categoriesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function uploadCategoryImage(fileData, onSuccess = null, onError = null) {
    adminPost('/CMS/Files/UploadRequests', fileData, onSuccess, (error) => {
        const errorMsg = 'Failed to upload image';
        adminState.categoriesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
// ==================== Vouchers ====================
function getVouchers(onSuccess = null) {
    adminGet("/Discounts?all=true", onSuccess);
}
function updateVoucher(id, voucherData, onSuccess = null, onError = null) {
    adminPut('/Discounts/' + id, voucherData, onSuccess, (error) => {
        if (onError)
            onError('Failed to update voucher');
    });
}
function getDiscountReport(onSuccess = null) {
    adminGet("/Discounts/Reports/Summary", onSuccess);
}
function getPaymentReport(onSuccess = null) {
    adminGet("/Payments/Reports/Summary", onSuccess);
}
// ==================== Merchants ====================
function getMerchants(onSuccess = null) {
    adminGet("/Merchants", onSuccess);
}
function saveMerchant(merchant, onSuccess = null, onError = null) {
    const url = '/Merchants' + (merchant.id ? '/' + merchant.id : '');
    const method = merchant.id ? 'put' : 'post';
    http()[method](getApi() + url, merchant)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error saving merchant:', error);
        if (onError)
            onError('Failed to save merchant');
    });
}
function deleteMerchant(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Merchants/' + id)
        .then(() => {
        if (onSuccess)
            onSuccess();
    })
        .catch((error) => {
        console.error('Error deleting merchant:', error);
        if (onError)
            onError('Failed to delete merchant');
    });
}
function testMerchantRegex(regex, onSuccess = null, onError = null) {
    adminPost('/Transactions/RegexSearchRequests?regex=' + encodeURIComponent(regex), null, onSuccess, onError);
}
// ==================== Marketplace Products ====================
function getProducts(onSuccess = null) {
    adminGet("/Products?onlyEnabled=false", onSuccess);
}
function saveProduct(product, onSuccess = null, onError = null) {
    const url = '/Products' + (product.id ? '/' + product.id : '');
    const method = product.id ? 'put' : 'post';
    http()[method](getApi() + url, product)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error saving product:', error);
        if (onError)
            onError('Failed to save product');
    });
}
function deleteProduct(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Products/' + id)
        .then(() => {
        if (onSuccess)
            onSuccess();
    })
        .catch((error) => {
        console.error('Error deleting product:', error);
        if (onError)
            onError('Failed to delete product');
    });
}
function getTransactionClassifications(onSuccess = null) {
    adminGet("/TransactionClassifications", onSuccess);
}
function getEffectiveClassifications(onSuccess = null) {
    adminGet("/V2/TransactionClassifications", onSuccess);
}
function getOpenBankingClassifications(onSuccess = null) {
    adminGet("/V2/OBTransactionClassifications", onSuccess);
}
function createTransactionClassification(data, onSuccess = null, onError = null) {
    adminPost('/V2/TransactionClassifications', data, onSuccess, () => {
        if (onError)
            onError('Failed to create classification');
    });
}
function updateTransactionClassification(id, data, onSuccess = null, onError = null) {
    adminPut('/V2/TransactionClassifications/' + id, data, onSuccess, (error) => {
        const msg = (error && error.response && error.response.data && error.response.data.message) || 'Failed to update classification';
        if (onError)
            onError(msg);
    });
}
function deleteTransactionClassification(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/V2/TransactionClassifications/' + id)
        .then((response) => {
        if (response && response.data && response.data.success) {
            if (onSuccess)
                onSuccess(response.data);
        }
        else {
            if (onError)
                onError((response && response.data && response.data.message) || 'Failed to delete classification');
        }
    })
        .catch(() => {
        if (onError)
            onError('Failed to delete classification');
    });
}
function remapOpenBankingClassification(obRow, mgClassification, onSuccess = null, onError = null) {
    const body = {
        id: obRow.id,
        classification: obRow.classification,
        subClassification: obRow.subClassification,
        mgClassification: {
            id: mgClassification.id,
            key: mgClassification.key,
            mgClassification: mgClassification.mgClassification,
            mgSubClassification: mgClassification.mgSubClassification,
            grandParentClassification: mgClassification.grandParentClassification,
            iconPath: mgClassification.iconPath,
            color: mgClassification.color,
            categoryColor: mgClassification.categoryColor
        }
    };
    adminPut('/V2/OBTransactionClassifications/' + obRow.id, body, (data) => {
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        const msg = (error && error.response && error.response.data && error.response.data.message) || 'Failed to remap classification';
        if (onError)
            onError(msg);
    });
}
// ==================== Logo Search Overrides ====================
function getLogoSearchOverrides(onSuccess = null) {
    adminGet("/LogoSearchOverrides", (result) => {
        if (onSuccess)
            onSuccess(result || []);
    });
}
function createLogoSearchOverride(data, onSuccess = null, onError = null) {
    adminPost('/LogoSearchOverrides', data, onSuccess, (error) => {
        if (onError)
            onError('Failed to create override');
    });
}
function updateLogoSearchOverride(id, data, onSuccess = null, onError = null) {
    adminPut('/LogoSearchOverrides/' + id, data, onSuccess, (error) => {
        if (onError)
            onError('Failed to update override');
    });
}
function deleteLogoSearchOverride(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/LogoSearchOverrides/' + id)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting logo search override:', error);
        if (onError)
            onError('Failed to delete override');
    });
}
export { 
// Categories
getCategories, createCategory, updateCategory, deleteCategory, uploadCategoryImage, 
// Vouchers
getVouchers, updateVoucher, getDiscountReport, getPaymentReport, 
// Merchants
getMerchants, saveMerchant, deleteMerchant, testMerchantRegex, getTransactionClassifications, 
// Marketplace Products
getProducts, saveProduct, deleteProduct, 
// Transaction Classifications admin
getEffectiveClassifications, getOpenBankingClassifications, createTransactionClassification, updateTransactionClassification, deleteTransactionClassification, remapOpenBankingClassification, 
// Logo Overrides
getLogoSearchOverrides, createLogoSearchOverride, updateLogoSearchOverride, deleteLogoSearchOverride, };
